const mediaMaxWidth899 = {
    "@media(max-width: 899px)": {
        width: "174px"
    }
};

const mediaMaxWidth839 = {
    "@media(max-width: 839px)": {
        width: "100%"
    }
};

const mediaMaxWidth839WithFlex = {
    "@media(max-width: 839px)": {
        width: "100%",
        flex: "1"
    }
};

const mediaMaxWidth599 = {
    "@media(max-width: 599px)": {
        marginRight: "16px"
    }
};

export {
    mediaMaxWidth899,
    mediaMaxWidth839,
    mediaMaxWidth839WithFlex,
    mediaMaxWidth599
};
